namespace GeniuzPOS.Purchase {
    export namespace PoPurInvoiceDtService {
        export const baseUrl = 'Purchase/PoPurInvoiceDt';

        export declare function Create(request: Serenity.SaveRequest<PoPurInvoiceDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PoPurInvoiceDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PoPurInvoiceDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PoPurInvoiceDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/PoPurInvoiceDt/Create",
            Update = "Purchase/PoPurInvoiceDt/Update",
            Delete = "Purchase/PoPurInvoiceDt/Delete",
            Retrieve = "Purchase/PoPurInvoiceDt/Retrieve",
            List = "Purchase/PoPurInvoiceDt/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PoPurInvoiceDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
